import { Component } from 'react';
import styled from 'styled-components';

const MainAreaElement = styled.main`
  grid-area: main;
  display: grid;
  grid-template-areas:
    'toparea toparea'
    'page   rightsidebar'
    'bottombar bottombar';
  grid-template-columns: 1fr auto;
  grid-template-rows: auto 1fr auto;
  overflow: hidden;
  /* Full height minus the 5px border throughout the app in My SaleCycle */
  height: calc(100vh - 5px);
` as any;

export class MainArea extends Component {
  public render() {
    return (
      <MainAreaElement {...this.props} id="mainArea" data-testid="MainArea" role="main">
        {this.props.children}
      </MainAreaElement>
    );
  }
}
